export default __webpack_public_path__ + "static/media/LogoWhit2.f3631a5b.svg";